import React, { Fragment } from 'react'
import { makeStyles } from '@material-ui/core'
import classNames from 'classnames'
import { useWrappedPosthog } from 'Components/PostHogProvider/hooks.js'
import { MailboxDiscount } from '../../../../Assets/Images/icons/mailboxDiscount.js'
import { Mailbox } from '../../../../Assets/Images/icons/mailbox.js'
import { Guide } from '../../../../Assets/Images/icons/guide.js'
import {
  CAMPAIGN_ENUM_TYPES,
  CAMPAIGN_SUBTYPES_ENUM,
  EDDM_SIGNUP,
} from '../../../../shared/constants'
import { isProduction } from '../../../../Utils/Functions/index.js'
import { authorization } from '../../../../Module/Auth/Auth'
import Banner from './Banner'
import BannerShopify from './BannerShopify/BannerShopify.jsx'
import { styles } from './styles'
import useSmallScreen from '../../../../Components/ClientDashboard/Components/CampaignCard/useSmallScreen.js'
import { MailboxMobile } from '../../../../Assets/Images/icons/mailboxMobile.js'

const useStyles = makeStyles(() => styles)
const Banners = ({
  hasSubmittedCampaigns,
  countryCode,
  handleCreateCampaign,
}) => {
  const classes = useStyles()
  const posthog = useWrappedPosthog()
  const smallScreen = useSmallScreen()
  const user = authorization.getUser()
  const { client } = user
  const isEddmSignup = client.createdBy === EDDM_SIGNUP

  // Shopify banner visibility: US, self-serve enabled, not EDDM-only
  const showShopifyBanner =
    countryCode === 'US' && client.isSelfServeEnabled && !isEddmSignup

  return (
    <Fragment>
      {/* Shopify Integration Banner */}
      <BannerShopify
        id="shopify-integration-banner"
        description="Import customers automatically and send personalized direct mail using ready-to-go segment templates."
        cypress_ids={{
          title: 'ShopifyBannerTitle',
          description: 'ShopifyBannerDescription',
          container: 'ShopifyBannerContainer',
          close: 'ShopifyBannerCloseBtn',
          button: 'ShopifyBannerConnectBtn',
        }}
        action={{
          button: 'Connect now',
          onClick: () => {
            if (posthog) {
              posthog.capture('Clicked Connect Now Button', {
                'event_category': 'Homepage',
                'button_label': 'Connect now',
                'banner_type': 'shopify_integration',
              })
            }
            window.open(process.env.REACT_APP_SHOPIFY_OPPIZI_APP_URL, '_blank')
          },
        }}
        isShow={showShopifyBanner}
      />

      {/* EDDM Discount Banner */}
      <Banner
        id={'EDDM-discount-banner'}
        cypress_id="EDDMBannerContainer"
        title={
          <Fragment>
            <span className={classes.desktopShow}>
              Get 10% off your first EDDM campaign!
            </span>
            <span className={classNames(classes.mobileShow, 'text-center')}>
              Try Our New EDDM Channel and Save 10%!
            </span>
          </Fragment>
        }
        description={
          'Click on the banner to redeem the offer, the coupon will be automatically applied to your campaign!'
        }
        cypress_ids={{
          title: 'EDDMBannerTitle',
          description: 'EDDMBannerBodyText',
          container: 'EDDMBannerContainer',
          close: 'EDDMBannerCloseBtn',
          icon: 'EDDMBannerIconContainer',
          button: 'EDDMBannerTryNowBtn',
        }}
        action={{
          button: 'Try now',
          onClick: () => {
            if (posthog) {
              posthog.capture('Clicked Try Now Button', {
                'event_category': 'Homepage',
                'button_label': 'Try now',
              })
              posthog.capture('Clicked OAds Home Top Banner', {
                'event_category': 'Homepage',
                'banner_type': 'first10',
              })
            }
            handleCreateCampaign(
              {
                type: CAMPAIGN_ENUM_TYPES.DIRECTMAIL,
                subtype: CAMPAIGN_SUBTYPES_ENUM.EDDM,
              },
              isProduction() ? 'EDDMFIRST10' : 'ADOPTION10',
            )
          },
        }}
        Icon={MailboxDiscount}
        isShow={countryCode === 'US' && !hasSubmittedCampaigns && isEddmSignup}
      />
      <Banner
        id={'EDDM-banner'}
        cypress_id="EDDMBannerContainer"
        title={"Boost Your Marketing with Promofy's New Local Direct Mail!"}
        description={
          'Reach homes in areas across the US with precise, targeted mail.'
        }
        cypress_ids={{
          title: 'EDDMBannerTitle',
          description: 'EDDMBannerBodyText',
          container: 'EDDMBannerContainer',
          close: 'EDDMBannerCloseBtn',
          icon: 'EDDMBannerIconContainer',
          button: 'EDDMBannerTryNowBtn',
        }}
        action={{
          button: 'Try now',
          onClick: () => {
            if (posthog) {
              posthog.capture('Clicked Try Now Button', {
                'event_category': 'Homepage',
                'button_label': 'Try now',
              })
            }
            handleCreateCampaign({
              type: CAMPAIGN_ENUM_TYPES.DIRECTMAIL,
              subtype: CAMPAIGN_SUBTYPES_ENUM.EDDM,
            })
          },
        }}
        Icon={() =>
          smallScreen ? (
            <Fragment>
              <MailboxMobile />
              <Guide />
            </Fragment>
          ) : (
            <Fragment>
              <Mailbox />
              <Guide />
            </Fragment>
          )
        }
        isShow={countryCode === 'US' && hasSubmittedCampaigns && isEddmSignup}
      />
    </Fragment>
  )
}
export default Banners
